/**
 * InitFTUE.js
 * A guided tour of the Permanent Benefits feature
 * Uses React Joyride Plugin
 * @author Rutvi Thakkar
 */
import React from "react";
import BaseComponent from '../../../BaseComponent';
import Joyride from "react-joyride";
import LocUtils from '../../../../util/localization/LocUtils'
import DataStore from "../../../../data/DataStore";
import StepComponent from './StepComponent';
import ServiceLocator from '../../../../ServiceLocator';

class InitFTUE extends BaseComponent {
    _stepStorageKey = "ftue1Step";
    state = {
        steps: [
            {
                target: ".fa-gift",
                content: <StepComponent step={1}
                    firstName={this.props.firstName} />,
                placement: "center",
                locale: {
                    next: LocUtils.T("feature.ftue.cta_1")
                }
            },
            {
                target: ".fa-gift",
                content: <StepComponent step={2} />,
                placement: "center",
                locale: {
                    next: LocUtils.T("feature.ftue.cta_2")
                }
            },
            {
                target: ".fa-gift",
                content: <StepComponent step={3} />,
                locale: {
                    next: LocUtils.T("feature.ftue.cta_3")
                }
            },
            {
                target: ".fa-gift",
                content: <StepComponent step={4} />,
                locale: {
                    last: LocUtils.T("feature.ftue.cta_4")
                }
            }
        ],
    };

    handleJoyrideCallback = (data) => {
        const { action } = data;

        //let newIndex = action !== "reset" ? parseInt(index) : parseInt(index) + 1;
        if(action === "reset"){
            ServiceLocator.Xing.Send(
                "farm2-game-frame",
                "UWG_SHOW_GAME",
                {}
            );
            DataStore.LocalStorage.Store(this._stepStorageKey, 1);
        }
        

    };

    render() {
        const { steps } = this.state;
        return (
            <div className="app">
                <Joyride
                    callback={this.handleJoyrideCallback}
                    disableOverlayClose={true}
                    continuous={true}
                    steps={steps}
                    locale={{
                        back: LocUtils.TPure("tour.controls.previous").toString()
                    }}
                    styles={{
                        options: {
                            primaryColor: '#3ba634'
                        },
                        buttonClose: {
                            display: 'none'
                        }
                    }}
                />
            </div>
        );
    }
}

export default InitFTUE;